import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { ReceiptButton } from "./ReceiptButton";
import { Money } from "./Money";
import { localPick } from "../../lib/localName";

// Drill-down: from the entry to every line and its account.
export const EntryDetail = ({ entry }) => {
  const { t, i18n } = useTranslation();
  const ar = i18n.language === "ar";

  return (
    <NeuCard className="p-5" data-testid="entry-detail">
      <p className="font-mono text-sm font-bold text-primary" dir="ltr">
        {entry.number} · {entry.date} · {entry.currency}
      </p>
      <p className="mt-1 text-sm font-semibold">{entry.description || "—"}</p>
      <div className="mt-2">
        <ReceiptButton url={entry.attachment_url} testId={`entry-receipt-${entry.id}`} />
      </div>
      <p className="mt-1 text-[11px] text-muted-foreground">
        {t("acct.createdBy")}: {entry.created_by} · {t("acct.source")}: {t(`acct.sources.${entry.source}`, entry.source)}
      </p>
      <div className="mt-4 grid gap-2">
        {entry.lines.map((line, index) => (
          <div key={index} className="flex items-center gap-3 rounded-xl px-2 py-2 shadow-neu-in" data-testid={`entry-line-${index}`}>
            <span className="font-mono text-xs font-bold" dir="ltr">{line.account_code}</span>
            <span className="min-w-0 flex-1 truncate text-xs font-semibold">
              {localPick(line, "account_name")}
            </span>
            <Money value={line.debit} currency={entry.currency} className="w-32 text-end text-xs" />
            <Money value={line.credit} currency={entry.currency} className="w-32 text-end text-xs" dim />
          </div>
        ))}
      </div>
      <div className="mt-3 flex justify-end gap-6 border-t border-border/50 pt-3 text-sm font-bold" dir="ltr">
        <Money value={entry.total_debit} currency={entry.currency} />
        <Money value={entry.total_credit} currency={entry.currency} />
      </div>
    </NeuCard>
  );
};
